import { configureStore } from "@reduxjs/toolkit";

// import dashboardReducer from './slices/dashboard'
import authReducer from './slices/auth'
import chatReducer from './slices/chat'
import utilReducer from './slices/utils'
import presentationReducer from './slices/presentation'

import permissionReducer from './slices/permission'
import userReducer from './slices/user'
import sourceReducer from './slices/source'
import groupReducer from './slices/group'
import visualizationReducer from './slices/visualization'
import dimensionDefaultsReducer from './slices/dimensionDefaults'
import dimVectorReducer from './slices/dimVector'

import databaseReducer from "./slices/database";
import tableReducer from "./slices/table";
import utilityReducer from "./slices/utility";
import queryReducer from "./slices/query";
import savedataReducer from "./slices/savedata";
import unionReducer from "./slices/union";
import reportReducer from "./slices/report";
import sheetReducer from "./slices/sheet";

const reducer = {
  auth: authReducer,
  // dashboard: dashboardReducer,
  chat: chatReducer,
  utils: utilReducer,
  permission: permissionReducer,
  user: userReducer,
  source: sourceReducer,
  group: groupReducer,
  presentation: presentationReducer,
  visualization: visualizationReducer,
  dimensionDefaults: dimensionDefaultsReducer,
  dimVector: dimVectorReducer,
  
  database: databaseReducer,
  table: tableReducer,
  utility: utilityReducer,
  query: queryReducer,
  savedata: savedataReducer,
  union: unionReducer,
  report: reportReducer,
  sheet: sheetReducer
}

const store = configureStore({  
  reducer: reducer,
  devTools: true
})

export default store;